// removed by extract-text-webpack-plugin
module.exports = {"customButtonContainer":"CustomButton__customButtonContainer___3lqxO","customButtonContainerForCoach":"CustomButton__customButtonContainerForCoach___1XaqV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomButton/CustomButton.scss
// module id = 1482
// module chunks = 0